

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export function Bio() {
  return (
    <div style={{ backgroundColor: '#fff', padding: '50px 0', opacity: '0.8' }}>
      <Container>
        <Row>
          <Col md={{ span: 10, offset: 1 }}>
            <div style={{ backgroundColor: '#f5f5f5', padding: '30px', borderRadius: '15px', boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)', fontFamily: "'Playfair', serif", fontSize: '20px', lineHeight: '1.6', opacity: '0.95' }}>
              <div style={{ marginBottom: '40px', textAlign: 'center' }}>
                <h1 style={{ fontFamily: "'Playfair', serif", fontSize: '36px', marginBottom: '20px', position: 'relative', opacity: '0.9' }}>About</h1>
              </div>
              <div style={{ marginBottom: '40px' }}>
              <p>Born in 1994, Dina Stojilković is a bright representative of a
new generation of pianists. She regularly performs across
Europe and has won numerous awards on both national and
international stages, including First Prizes at the Savshinski
International Competition in Saint Petersburg and the XV
Petar Konjović International Competition in Belgrade. In
recognition of her exceptional talent, she was named
Serbia’s most promising pianist by the Isidor Bajić Piano
Festival in Novi Sad. Stojilković launched her solo career at
the age of 13, performing with one of Serbia’s most
renowned chamber ensembles, the Belgrade Chamber
Orchestra ‘Dušan Skovran,’ at the Kolarac Concert Hall in
Belgrade. She has also received numerous scholarships for
her merit and has been supported by the German Music
Council, the Yehudi Menuhin “Live Music Now”
Foundation, and the Serbian Ministry of Youth and Sport.</p>
              </div>
              <div style={{ marginBottom: '40px' }}>
              <p>Her musical versatility extends to chamber music, where she
actively collaborates with various ensembles in her current
home, Berlin. Stojilković’s pianistic journey has been
shaped by world-renowned artists and pedagogues,
including Ewa Kupiec, Bernd Goetzke, Fil Liotis, and
Alfredo Perl. She has also benefited from the guidance of
masters such as Alfred Brendel, Arbo Valdma, Dame Imogen
Cooper, Florian Ludwig, Frans Helmerson, and Ivan
Klánský.</p>
              </div>
              <div style={{ marginBottom: '40px' }}>
              <p>Stojilkovic is also a respected pedagogue, with
several of her students winning prestigious awards.</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
